import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const RenewLeaseModal = ({ show, onClose, onSubmit, lease }) => {
  const [commenceDate, setCommenceDate] = useState('');
  const [expireDate, setExpireDate] = useState('');

  const handleSubmit = () => {
    if (!commenceDate || !expireDate) {
      alert('Please fill in both dates');
      return;
    }
 
    if (new Date(commenceDate) >= new Date(expireDate)) {
      alert('Expiration date must be after commencement date');
      return;
    }

    onSubmit({ commenceDate, expireDate });
    setCommenceDate('');
    setExpireDate('');
  };

  const handleClose = () => {
    setCommenceDate('');
    setExpireDate('');
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Renew Lease :  {lease ? lease.propertyaddress : ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formCommenceDate">
            <Form.Label>Commencement Date</Form.Label>
            <Form.Control
              type="date"
              value={commenceDate}
              onChange={(e) => setCommenceDate(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formExpireDate" className="mt-3">
            <Form.Label>Expiration Date</Form.Label>
            <Form.Control
              type="date"
              value={expireDate}
              onChange={(e) => setExpireDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className='bg-danger' onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Renew
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RenewLeaseModal;
